import React, { useState, useEffect } from 'react';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { createQiniuTokenApi } from '@service';

const UploaderApp = ({ getUploadFiles, setOthersValue }) => {
  const [prefix, setPrefix] = useState('');
  const [token, setToken] = useState('');

  const getQiniuToken = async () => {
    const res = await createQiniuTokenApi({
      method: 'post',
      token: 'yunpan',
    });
    const { token, prefix } = res.data;

    setPrefix(prefix);
    setToken(token);
  };

  useEffect(() => {
    getQiniuToken();
  }, []);

  const getNecessaryParam = filename => {
    const key = prefix + '/' + filename;

    return {
      key,
      token,
      'x:prefix': prefix,
    };
  };

  const props = {
    name: 'file',
    action: 'https://upload.qiniup.com',

    onChange(info) {
      if (info.file.status !== 'uploading') {
        if (!info.fileList || info.fileList.length === 0) {
          getUploadFiles([]);
          setOthersValue('update_url', null);
        }
      }
      if (info.file.status === 'done') {
        getUploadFiles(info.fileList);
        setOthersValue('update_url', info.file.response.domain + '/' + info.file.response.key);
        message.success(`${info.file.name} 上传成功！`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 上传失败.`);
      }
    },
    accept: '.apk',
    data: file => getNecessaryParam(file.name),
  };

  return (
    <Upload {...props}>
      <Button icon={<UploadOutlined />}>上传安装包</Button>
    </Upload>
  );
};

export default UploaderApp;
